module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "microphoneSelect flexcenter"
  }, [_c('transition', [_c('div', {
    staticClass: "microphoneSelectDialog flexcenter"
  }, [_c('div', {
    staticClass: "modal-close",
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "microphoneSelectInner"
  }, [_c('h3', [_vm._v("マイク設定")]), _vm._v(" "), _c('div', {
    staticClass: "modal-inner"
  }, [_c('div', {
    staticClass: "select1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sreUse),
      expression: "sreUse"
    }],
    attrs: {
      "type": "radio",
      "id": "sreUseYes",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.sreUse, "true")
    },
    on: {
      "change": function($event) {
        _vm.sreUse = "true"
      }
    }
  }), _c('label', {
    attrs: {
      "for": "sreUseYes"
    }
  }, [_vm._v("音声機能を使用する")]), _vm._v(" "), _c('div', {
    staticClass: "flexstart-align content",
    class: _vm.sreUse
  }, [_c('div', {
    staticClass: "item"
  }, [_c('h4', [_vm._v("マイクの選択")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "devices"
  }, _vm._l((_vm.microphones), function(microphone, index) {
    return _c('div', {
      staticClass: "device"
    }, [_c('div', {
      staticClass: "font12",
      class: {
        active: microphone.selected && _vm.sreUse == 'true'
      },
      on: {
        "click": function($event) {
          return _vm.selectMicrophone(index)
        }
      }
    }, [_vm._v(_vm._s(microphone.name))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "buttons buttons-setting flexbetween"
  }, [_c('button', {
    staticClass: "reload flexcenter",
    attrs: {
      "type": "button",
      "disabled": _vm.sreUse === 'false'
    },
    on: {
      "click": _vm.updateList
    }
  }, [_c('span', [_vm._v("一覧を更新")])]), _vm._v(" "), _c('button', {
    staticClass: "help flexcenter",
    attrs: {
      "type": "button",
      "disabled": _vm.sreUse === 'false'
    },
    on: {
      "click": function($event) {
        return _vm.$emit('showMicrophoneHelp')
      }
    }
  }, [_c('span', [_vm._v("マイク設定について")])])]), _vm._v(" "), _c('p', {
    staticClass: "font12"
  }, [_vm._v("※お使いのマイクがこの一覧に表示されないときは、マイクが接続されていることを確認してから、[一覧を更新]をクリックしてください。")]), _vm._v(" "), _c('p', {
    staticClass: "font12"
  }, [_vm._v("※マイク設定について詳しくは、[マイク設定について]をクリックしてください。")])])])]), _vm._v(" "), _c('div', {
    staticClass: "select2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sreUse),
      expression: "sreUse"
    }],
    attrs: {
      "type": "radio",
      "id": "sreUseNo",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.sreUse, "false")
    },
    on: {
      "change": function($event) {
        _vm.sreUse = "false"
      }
    }
  }), _c('label', {
    attrs: {
      "for": "sreUseNo"
    }
  }, [_vm._v("音声機能を使用しない")])])]), _vm._v(" "), _c('div', {
    staticClass: "buttons buttons-footer flexcenter"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("キャンセル")]), _vm._v(" "), _c('button', {
    staticClass: "continue",
    attrs: {
      "type": "button",
      "disabled": (_vm.sreUse == 'true' && _vm.selectedMicrophone == null)
    },
    on: {
      "click": _vm.doContinue
    }
  }, [_vm._v("続行")])])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4c9026ae", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-4c9026ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MicrophoneSelect.vue
// module id = 623
// module chunks = 1